export const environment = {
  production: true,
  billingEmail: "sales@glitchtip.com",
};
